import { usePresentationApprovalWorkflowEnabled } from '@/modules/tenant/TenantDetailsContext/hooks/usePresentationApprovalWorkflowEnabled';

import { usePresentationApprovalBadgeCountQuery } from './graphql/PresentationApprovalBadge.generated';

/**
 * usePresentationApprovalBadgeCount returns the number of presentation
 * approval requests for the current user that are new since the user last
 * viewed the approvals list. It returns 0 when the approval workflow is off
 * or the user is not an employee.
 *
 * The hook reads only the Apollo cache. The notifications query loads the
 * count, the notifications subscription refreshes it when a request arrives,
 * and the Tasks page resets it when the user views the approvals list.
 */
export function usePresentationApprovalBadgeCount(): number {
  const isWorkflowEnabled = usePresentationApprovalWorkflowEnabled();
  const { data } = usePresentationApprovalBadgeCountQuery({
    skip: !isWorkflowEnabled,
    fetchPolicy: 'cache-only',
  });

  if (!isWorkflowEnabled) return 0;
  // A user has at most one employee in a tenant, and the server limits
  // currentUser.employees to the current tenant, so the first entry is the
  // only one.
  return (
    data?.currentUser?.employees?.[0]?.newPresentationApprovalRequestCount ?? 0
  );
}
